import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MutateEntity = _resolveComponent("MutateEntity")!

  return (_openBlock(), _createBlock(_component_MutateEntity, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
    enUK: _ctx.enUK,
    entityProps: {
      id: _ctx.project.id,
      name: _ctx.project.name,
      defaultPaymentOption: _ctx.project.defaultPaymentOption,
      needsBudgetApproval: _ctx.project.needsBudgetApproval,
      budgetTracking: _ctx.project.budgetTracking,
      plannedTimeTracking: _ctx.project.plannedTimeTracking,
      estimationUnit: _ctx.project.estimationUnit,
      velocity: _ctx.project.velocity != null ? Number(_ctx.project.velocity) : 1,
    },
    validationRules: _ctx.validationRules,
    updatePaginatedQueryCache: _ctx.updateProject,
    mutation: _ctx.UPDATE_PROJECT,
    mutationName: "updateProject",
    formOptions: _ctx.formOptions,
    messages: _ctx.messages,
    refetchQueries: _ctx.refetchQueries
  }, null, 8, ["enUK", "entityProps", "validationRules", "updatePaginatedQueryCache", "mutation", "formOptions", "messages", "refetchQueries"]))
}